import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ConfirmDialog2Data } from "../../settings/settings.component";
import { ChangeDetectionStrategy, Component, Inject, inject } from "@angular/core";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-dialog-2',
  standalone: false,
  templateUrl: './confirm-dialog-2.component.html',
  styleUrl: './confirm-dialog-2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialog2Component {
  private readonly translate = inject(TranslateService);
  inputValue: string = '';
  comments: string = '';
  commentsPlaceholder: string = '';
  onConfirmClick?: () => void;

  constructor(
    private dialogRef: MatDialogRef<ConfirmDialog2Component>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialog2Data
  ) {
    // Set defaults
    this.data.confirmButtonText = this.data.confirmButtonText || this.translate.instant('COMMON.BUTTONS.YES');
    this.data.cancelButtonText = this.data.cancelButtonText || this.translate.instant('COMMON.BUTTONS.CANCEL');
    this.data.icon = this.data.icon || (this.data.title.includes('Open') ? 'lock_open' : 'lock');
    this.inputValue = this.data.inputValue || '';
    this.comments = this.data.comments || '';
    this.commentsPlaceholder = this.data.commentsPlaceholder || '';
  }

  onConfirm(): void {
    if (this.onConfirmClick) {
      this.onConfirmClick();
    } else {
      if (this.data.showInput) {
        this.dialogRef.close({ confirmed: true, inputValue: this.inputValue });
      } else {
        this.dialogRef.close(true);
      }
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  isConfirmDisabled(): boolean {
    return this.data.showInput === true && this.data.inputRequired === true && !this.inputValue.trim();
  }
}
